module.exports = __webpack_public_path__ + "img/sign-2.3d10b4fd.jpg";